import { RiBilliardsFill } from '@react-icons/all-files/ri/RiBilliardsFill';

export const DealSubmissionMatchTitle = ({ description, isLowBallOffer }) => (
  <>
    {description}
    {isLowBallOffer && <RiBilliardsFill />}
  </>
);
